import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type PeerFeedbackTemplateFragment = { id: string, name: string, templates: Array<{ text: string }> };


export type PeerFeedbackTemplateFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const PeerFeedbackTemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment PeerFeedbackTemplate on PeerFeedbackTemplateSchema {
  id
  name
  templates {
    text
  }
}
    `;